'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$10() {
  this.bcR = null;
  this.bcP = null;
  this.bcQ = false;
  this.bcN = null;
  this.bcO = false;
  this.bcS = false;
  this.bcT = false;
  this.bcR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$10 as $c_Lpresto_PrestoRouter$$anon$10 };
$p = $c_Lpresto_PrestoRouter$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$10;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$10() {
}
export { $h_Lpresto_PrestoRouter$$anon$10 as $h_Lpresto_PrestoRouter$$anon$10 };
$h_Lpresto_PrestoRouter$$anon$10.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bcR;
});
$p.t = (function() {
  if ((!this.bcQ)) {
    this.bcP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcQ = true;
  }
  return this.bcP;
});
$p.ae = (function() {
  if ((!this.bcO)) {
    this.bcN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().jV(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().adA(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcO = true;
  }
  return this.bcN;
});
$p.w = (function() {
  if ((!this.bcT)) {
    this.bcS = false;
    this.bcT = true;
  }
  return this.bcS;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$10, "presto.PrestoRouter$$anon$10", ({
  Nn: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$10 as $d_Lpresto_PrestoRouter$$anon$10 };
//# sourceMappingURL=presto.-Presto-Router$$anon$10.js.map
